<template>
    <span class="product-credit">
        <a href="https://dolyame.ru/" rel="nofollow" target="_blank" class="flex justify-center items-center">
            <span class="icon dolyame mr-2"></span>
            <span>или 4 платежа по <span>{{ paymentPartPrice }}</span>  ₽</span>
        </a>
    </span>
</template>

<script>
export default {
    props: {
        price: {
            required: true,
            type: Number
        }
    },
    computed: {
        paymentPartPrice() {
            return this.$root.priceFormat(this.price / 4);
        }
    }
}
</script>
